export function filterPath(
  target: any,
  path: PropertyKey[],
  filter: (value: any, key: PropertyKey) => boolean
): PropertyKey[] {
  if (typeof target !== 'object' || target === null) {
    return []
  }

  let currentTarget = target
  const filteredPath = []

  for (const key of path) {
    if (filter(currentTarget, key)) {
      filteredPath.push(key)
      if (typeof currentTarget === 'object' && currentTarget !== null) {
        currentTarget = currentTarget[key]
      }
    } else {
      break
    }
  }

  return filteredPath
}
